import { useEffect, useRef } from 'react';
import { useOnScreen } from '../../../hooks/useOnScreen';
import { Klydo } from '../../../api/klydo';
import { DEFAULT_KLYDO_THEME } from '../../../consts/general';

const secondsForMin = 3600;
const secondsForHour = 43200;
type UseKlydoPlayerProps = {
  klydo: Partial<Klydo>;
  minutesValue?: number;
  hoursValue?: number;
};

const useKlydoPlayer = ({
  klydo,
  minutesValue,
  hoursValue,
}: UseKlydoPlayerProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const minuteHandRef = useRef<HTMLDivElement>(null);
  const hourHandRef = useRef<HTMLDivElement>(null);
  const hourHandShadowRef = useRef<HTMLDivElement>(null);
  const minuteHandShadowRef = useRef<HTMLDivElement>(null);
  const isVisible = useOnScreen(ref);
  const loopUrl = klydo.klydoAnimation?.l || klydo.loopUrl;
  const photoUrl = klydo.photoUrl;
  const previewFrameSeconds = klydo.metadata?.previewFrameSeconds;

  useEffect(() => {
    const updHands = () => {
      const dt = new Date();
      if (hoursValue !== undefined && minutesValue !== undefined) {
        dt.setHours(hoursValue);
        dt.setMinutes(minutesValue);
      }

      const seconds = dt.getMinutes() * 60 + dt.getSeconds();
      const dgmin = (seconds / secondsForMin) * 360;
      if (minuteHandRef.current) {
        minuteHandRef.current.style.transform = `rotate(${dgmin}deg)`;
      }
      if (minuteHandShadowRef.current) {
        minuteHandShadowRef.current.style.transform = `rotate(${dgmin}deg)`;
      }
      const hours = (dt.getHours() % 12) * 3600 + seconds;
      const dgh = (hours / secondsForHour) * 360;
      if (hourHandRef.current) {
        hourHandRef.current.style.transform = `rotate(${dgh}deg)`;
      }
      if (hourHandShadowRef.current) {
        hourHandShadowRef.current.style.transform = `rotate(${dgh}deg)`;
      }
    };
    updHands();
  }, [isVisible, minutesValue, hoursValue]);

  return {
    ref,
    minuteHandRef,
    hourHandRef,
    hourHandShadowRef,
    minuteHandShadowRef,
    isVisible,
    loopUrl,
    handsColor: klydo?.theme?.handsColor || DEFAULT_KLYDO_THEME.handsColor,
    backgroundColor:
      klydo?.theme?.backgroundColor || DEFAULT_KLYDO_THEME.backgroundColor,
    pendulumColor:
      klydo?.theme?.pendulumColor || DEFAULT_KLYDO_THEME.pendulumColor,
    pendulumRodColor:
      klydo?.theme?.pendulumRodColor || DEFAULT_KLYDO_THEME.pendulumRodColor,
    dialsColor: klydo?.theme?.dialsColor || DEFAULT_KLYDO_THEME.dialsColor,
    photoUrl,
    previewFrameSeconds,
    time: {
      hoursValue,
      minutesValue,
    },
  };
};
export default useKlydoPlayer;
